import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'reflexbox/styled-components'
import styled from 'styled-components'

import theme from 'theme'

const TableContainer = styled(Box).attrs({
  maxWidth: '100%',
  overflow: 'auto',
})``

const StyledTable = styled(Box).attrs({ as: 'table', width: '100%' })``

const Th = styled(Box).attrs({
  as: 'th',
  bg: theme.colors.blues[20],
  py: '10px',
  px: '12px',
  textAlign: 'left',
})`
  border-color: ${theme.colors.black};
  border-top-width: 1px;
  border-top-style: solid;
  border-right-width: 1px;
  border-right-style: solid;

  &:first-of-type {
    border-left-width: 1px;
    border-left-style: solid;
  }
`

const Td = styled(Box)
  .attrs({
    as: 'td',
    py: '10px',
    px: '12px',
    bg: theme.colors.white,
  })
  .withConfig({
    shouldForwardProp: (prop) => ['isTitle'].indexOf(prop) === -1,
  })`
  border-color: ${theme.colors.black};
  border-top-width: 1px;
  border-top-style: solid;
  border-right-width: 1px;
  border-right-style: solid;
  font-weight: ${({ isTitle }) => (isTitle ? theme.fontWeights.bold : theme.fontWeights.normal)};

  &:first-of-type {
    border-left-width: 1px;
    border-left-style: solid;
  }
`

const Tr = styled(Box).attrs({ as: 'tr' })``

const TBody = styled(Box).attrs({ as: 'tbody' })`
  ${Tr} {
    &:last-of-type {
      ${Td} {
        border-bottom-width: 1px;
        border-bottom-style: solid;
      }
    }

    &:nth-child(even) {
      ${Td} {
        background-color: ${theme.colors.blacks[5]};
      }
    }
  }
`

const THead = styled(Box).attrs({ as: 'thead' })``

const SanityTable = ({ rows, headersInFirstColumn = false, ...others }) => {
  const heading = rows[0]
  const body = rows.slice(1)

  return (
    <TableContainer {...others}>
      <StyledTable>
        <THead>
          <Tr>
            {heading.cells.map((cell, index) => (
              <Th key={index}>{cell}</Th>
            ))}
          </Tr>
        </THead>
        <TBody>
          {body.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              {row.cells.map((cell, cellIndex) => (
                <Td
                  key={cellIndex}
                  isTitle={headersInFirstColumn && cellIndex === 0}
                >
                  {cell}
                </Td>
              ))}
            </Tr>
          ))}
        </TBody>
      </StyledTable>
    </TableContainer>
  )
}

SanityTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  headersInFirstColumn: PropTypes.bool,
}
export default SanityTable
